var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.58005 19.8889L2.56005 19.9089C2.29005 19.3189 2.12005 18.6489 2.05005 17.9089C2.12005 18.6389 2.31005 19.2989 2.58005 19.8889Z",
    fill: "#6374FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00012 11.2589C10.3146 11.2589 11.3801 10.1933 11.3801 8.8789C11.3801 7.56446 10.3146 6.4989 9.00012 6.4989C7.68568 6.4989 6.62012 7.56446 6.62012 8.8789C6.62012 10.1933 7.68568 11.2589 9.00012 11.2589Z",
    fill: "#6374FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 2.87891H7.81C4.17 2.87891 2 5.04891 2 8.68891V17.0689C2 18.1589 2.19 19.1089 2.56 19.9089C3.42 21.8089 5.26 22.8789 7.81 22.8789H16.19C19.83 22.8789 22 20.7089 22 17.0689V14.7789V8.68891C22 5.04891 19.83 2.87891 16.19 2.87891ZM20.37 13.3789C19.59 12.7089 18.33 12.7089 17.55 13.3789L13.39 16.9489C12.61 17.6189 11.35 17.6189 10.57 16.9489L10.23 16.6689C9.52 16.0489 8.39 15.9889 7.59 16.5289L3.85 19.0389C3.63 18.4789 3.5 17.8289 3.5 17.0689V8.68891C3.5 5.86891 4.99 4.37891 7.81 4.37891H16.19C19.01 4.37891 20.5 5.86891 20.5 8.68891V13.4889L20.37 13.3789Z",
    fill: "#6374FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.17876e893580ef00f6d500286670771c.svg";
export { ForwardRef as ReactComponent };